import { ScrollControlVariants } from '../../../../../components/scrollControl/types/scrollControlVariants';
import { commonVariantToken } from './commonStateTokens';
export const getScrollControlStyles = (FOUNDATIONS, FONT) => ({
    [ScrollControlVariants.DEFAULT]: {
        ...commonVariantToken(FOUNDATIONS, {}),
    },
});
//# sourceMappingURL=styles.js.map